import { COLOR, mq, Icon as _Icon } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

const BUTTON_HEIGHT = 80;
const DISPLAY_ITEMS_HEIGHT = {
  PC: 600,
  /** memo calculation 58px * 20 */
  SP: 1160,
};

export const DivRootProductInfo = styled.div<{
  isOverTwentyInfo: boolean;
  isShowRemainingItems: boolean;
  scrollHeight: number;
}>`
  display: flex;
  justify-content: space-between;
  margin: 32px 0;
  overflow: hidden;

  height: ${({ isOverTwentyInfo, isShowRemainingItems, scrollHeight }) => {
    // 20件以下であれば要素サイズに依存させる
    if (!isOverTwentyInfo) return "auto";
    return isOverTwentyInfo && isShowRemainingItems
      ? `${scrollHeight + BUTTON_HEIGHT}px`
      : `${DISPLAY_ITEMS_HEIGHT.PC}px`;
  }};

  ${mq.sp} {
    flex-direction: column;
    justify-content: flex-start;
    margin: 16px 0;
    height: ${({ isOverTwentyInfo, isShowRemainingItems, scrollHeight }) => {
      // 20件以下であれば要素サイズに依存させる
      if (!isOverTwentyInfo) return "auto";
      return isOverTwentyInfo && isShowRemainingItems
        ? `${scrollHeight + BUTTON_HEIGHT}px`
        : `${DISPLAY_ITEMS_HEIGHT.SP}px`;
    }};
  }
`;

export const ButtonWrapper = styled.button`
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${BUTTON_HEIGHT}px;
  width: 100%;
  cursor: pointer;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, ${COLOR.GRAY50.code} 100%);
`;

export const Icon = styled(_Icon)<{ isShowRemainingItems: boolean }>`
  transform: rotate(${({ isShowRemainingItems }) => (isShowRemainingItems ? 180 : 0)}deg);
`;
